import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { updateAgendaState, useAgendaFromHistory, updateAgenda, resetHistorySelection } from '../../../../store/details/agenda/actions';

import DatePicker from 'react-date-picker';
import { DetailsAgendaState } from '../../../../store/details/agenda/types';
import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { TextField } from '@mui/material';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './agenda.module.css';
import { AgendaHistoryTable } from './agenda-history-table';

interface PropsFromState {
  readonly agenda: DetailsAgendaState;
  readonly currentLanguage: string;
}

interface PropsFromDispatch {
  readonly updateAgendaState: typeof updateAgendaState;
  readonly useAgendaFromHistory: typeof useAgendaFromHistory;
  readonly updateAgenda: typeof updateAgenda;
  readonly resetHistorySelection: typeof resetHistorySelection;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class Agenda extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <div className={styles.container}>
        <h2 className={styles.header}>{this.localization.get('details.agenda.header')}</h2>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.text}>
                {this.localization.get('details.agenda.reference')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input} disabled={this.props.agenda.selectedHistoryId > 0}
                placeholder={this.localization.get('details.agenda.referencePlaceholder')}
                value={this.props.agenda.agendaReference}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateAgendaState({ ...this.props.agenda, agendaReference: event.target.value });
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.text}>
                {this.localization.get('details.agenda.plannedOnDate')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.input}>
                <DatePicker
                  disabled={this.props.agenda.selectedHistoryId > 0}
                  value={this.props.agenda.plannedOnDate ? new Date(this.props.agenda.plannedOnDate) : ''}
                  locale={this.props.currentLanguage}
                  onChange={(date: Date) => {
                    this.props.updateAgendaState({
                      ...this.props.agenda,
                      plannedOnDate: date.toISOString(), // Serialize as ISO string
                      plannedOnTime: this.props.agenda.plannedOnTime !== ''
                        ? this.props.agenda.plannedOnTime
                        : '12:00'
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.text}>
                {this.localization.get('details.agenda.plannedOnTime')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.input}>
                <TextField
                  disabled={this.props.agenda.selectedHistoryId > 0}
                  type='time'
                  value={this.props.agenda.plannedOnTime}
                  placeholder={this.localization.get('details.agenda.plannedOnTimePlaceholder')}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateAgendaState({ ...this.props.agenda, plannedOnTime: event.target.value });
                  }} />
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.text}>
                {this.localization.get('details.agenda.status')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                placeholder={this.localization.get('details.agenda.statusPlaceholder')}
                value={this.props.agenda.status}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateAgendaState({ ...this.props.agenda, status: event.target.value });
                }} />
            </div>
          </div>
          <div className={styles.actionBar}>
            <div
              className={styles.resetButton}
              onClick={() => {
                  if (this.props.agenda.selectedHistoryId) {
                    this.props.resetHistorySelection();
                  }
                }
              }
            >
                <span className={styles.buttonText}>{this.localization.get('details.agenda.resetHistorySelection')}</span>
            </div>
            <img alt=""
              className={styles.saveButton}
              src={require('../../../../assets/images/save_85x85.png')}
              onClick={() => { this.props.updateAgenda(); }}
            />
          </div>
          {this.props.agenda && this.props.agenda.agendaHistoryAuditList && this.props.agenda.agendaHistoryAuditList.length > 0 &&
            <div className={styles.rowContainer}>
              <AgendaHistoryTable
                title={this.localization.get('details.agenda.history')}
                currentLanguage={this.props.currentLanguage}
                rows={this.props.agenda.agendaHistoryAuditList}
                useAgendaFromHistory={this.props.useAgendaFromHistory}
                selectedHistoryId={this.props.agenda.selectedHistoryId} />
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsAgenda }, shared: { currentLanguage } }: ApplicationState): PropsFromState => ({
  agenda: detailsAgenda,
  currentLanguage: currentLanguage
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  updateAgendaState: (agendaState: DetailsAgendaState) => dispatch(updateAgendaState(agendaState)),
  useAgendaFromHistory: (agendaHistoryAuditId: number) => dispatch(useAgendaFromHistory(agendaHistoryAuditId)),
  updateAgenda: () => dispatch(updateAgenda()),
  resetHistorySelection: () => dispatch(resetHistorySelection())
});

export default connect(mapStateToProps, mapDispatchToProps)(Agenda);
